import React from 'react';
import I18n from 'i18n-js';
import readingIcon from '@/../images/icons/reading.svg';
import calendarPlusIcon from 'images/icons/calendar-plus.svg';
import calendarCheckedIcon from 'images/icons/calendar-checked.svg';
import useLessonOverviewContext from '@/components/shared/NewLessonOverview/useLessonOverviewContext';
import Tooltip from '@/components/common/Tooltip';
import { ConditionalWrap } from '@/components/common/Utils';
import * as Routes from 'modules/routes';
import { IReferenceMaterial } from '../types';
import { referenceMaterialLabel } from '../DiveDeeper.utils';

type CardProps = {
  referenceMaterial?: IReferenceMaterial;
  openAssign: () => void;
  setInitialValues: (any) => void;
};

const ReferenceMaterialCard = ({ referenceMaterial, openAssign, setInitialValues }: CardProps) => {
  const { i18Key } = referenceMaterialLabel(referenceMaterial.type);
  const isStaffer = useLessonOverviewContext(state => state.isStaffer);
  const icon = referenceMaterial.isAssigned ? calendarCheckedIcon : calendarPlusIcon;
  const programId = useLessonOverviewContext(state => state.programId);
  const lessonId = useLessonOverviewContext(state => state.lessonId);

  const onAssignmentButtonClick = () => {
    if (referenceMaterial.isAssigned && setInitialValues) return;

    setInitialValues({
      modelType: referenceMaterial.type,
      modelsToAssign: [{
        label: referenceMaterial.label,
        score: referenceMaterial.maxScore,
        value: `ReferenceMaterial-${referenceMaterial.id}`,
      }],
    });
    openAssign();
  };

  const tooltipContent = () => (
    <div>
      An assignment has been created for this content.
      <a href={Routes.teacher_program_assignments_path(programId, { lesson_id: lessonId })}> View Details</a>
    </div>
  );

  return (
    <div className="tw-border tw-border-solid tw-border-med-grey tw-shadow-lg tw-max-w-3xl tw-rounded-lg
        tw-h-[4.5rem] tw-flex tw-justify-start tw-items-center tw-bg-white"
    >
      <div className="tw-flex tw-justify-center tw-items-center tw-rounded-lg tw-bg-blue tw-min-h-[2.5rem]
          tw-min-w-[2.5rem] tw-mx-[1rem]"
      >
        <img alt="book-icon" className="tw-invert" src={readingIcon} />
      </div>
      <a className="tw-text-[16px] tw-mb-0 tw-text-tci-purple tw-w-[67%] tw-mr-auto" href={referenceMaterial.href}>
        {`${I18n.t(i18Key)}: ${referenceMaterial.label}`}
      </a>
      {isStaffer && (
        <ConditionalWrap
          condition={referenceMaterial.isAssigned && isStaffer}
          wrap={children => (
            <Tooltip content={tooltipContent()}>
              {children}
            </Tooltip>
          )}
        >
          <button
            className="tw-bg-transparent tw-border-none focus:tw-border-none active:tw-border-none tw-cursor-pointer
              focus:tw-outline-none"
            type="button"
            onClick={onAssignmentButtonClick}
          >
            <img
              alt="calendar-plus icon"
              className="tw-mr-[1rem]"
              src={icon}
            />
          </button>
        </ConditionalWrap>
      )}
    </div>
  );
};
export default ReferenceMaterialCard;
